<template>
  <div>
    <v-progress-linear v-if="loading"></v-progress-linear>
    <document-manager class="pa-1" :modelObj.sync="modelObj" :module="moduleType" v-if="showDocuments"></document-manager>
  </div>
</template>
<script>
export default {
  data () {
    return {
      modelObj: {},
      moduleType: null,
      loading: false,
      showDocuments: false
    }
  },
  components: {
    'document-manager': () => import('@/components/Documents/ModulesDocuments')
  },
  mounted () {
    this.getDetails()
  },
  methods: {
    getDetails () {
      this.loading = true
      this.moduleType = this.SP_CUSTOMER
      this.$_executeApi('get', `customers/${this.$route.params.crm_id}`).then(response => {
        this.modelObj = response.data
        this.loading = false
        this.showDocuments = true
      })
    }
  }
}
</script>
